<template>
  <div class="el-tabs-container">
    <el-tabs v-model="tab_index">
      <el-tab-pane label="查询编辑">
        <span slot="label"><i class="iconfont icon-edit" style="font-size: 14px"></i>&nbsp;{{$t("tab.tab_search_and_edit")}}</span>
        <ProductionCapacityAdd></ProductionCapacityAdd>
      </el-tab-pane>
      <el-tab-pane label="导入">
        <span slot="label"><i class="iconfont icon-export-in" style="font-size: 14px"></i>&nbsp;{{$t("tab.tab_import")}}</span>
        <ProductionCapacityExport></ProductionCapacityExport>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ProductionCapacityAdd from "./ProductionCapacityAdd";
import ProductionCapacityExport from "./ProductionCapacityExport";

export default {
  name: "ProductionCapacity",
  components: {
    ProductionCapacityAdd,
    ProductionCapacityExport
  },
  data() {
    return {
      tab_index: 0
    };
  },
  created() { },
  methods: {}
};
</script>
